// components/AssignmentUpload.jsx
import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';

const AssignmentUpload = () => {
  const [file, setFile] = useState(null);

  const handleUpload = () => {
    if (file) {
      alert(`File uploaded: ${file.name}`);
    }
  };

  return (
    <div>
      <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      <Button variant="contained" onClick={handleUpload}>
        Upload
      </Button>
    </div>
  );
};

export default AssignmentUpload;